import { PushToSftpModalTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { TableCellType, TableHeader } from "../../../custom-table/table";

export const generatePushToSftpTableData = (
  showDownloadColumn: boolean = false,
  hideCheckboxColumn: boolean = false,
): TableHeader[] => {
  const headers: TableHeader[] = [];

  if (!hideCheckboxColumn) {
    headers.push({
      label: "",
      key: PushToSftpModalTableColumnKeys.SELECT,
      order: 1,
      width: 5,
      type: TableCellType.CHECKBOX,
    });
  }

  headers.push(
    {
      label: "Filename",
      key: PushToSftpModalTableColumnKeys.FILENAME,
      order: hideCheckboxColumn ? 1 : 2,
      width: showDownloadColumn ? 45 : hideCheckboxColumn ? 55 : 50,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "DOW",
      key: PushToSftpModalTableColumnKeys.DUMPED_AT,
      order: hideCheckboxColumn ? 2 : 3,
      width: showDownloadColumn ? 17 : hideCheckboxColumn ? 20 : 18,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Receive Time",
      key: PushToSftpModalTableColumnKeys.RECEIVE_TIME,
      order: hideCheckboxColumn ? 3 : 4,
      width: showDownloadColumn ? 20 : hideCheckboxColumn ? 25 : 22,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Input Rec#",
      key: PushToSftpModalTableColumnKeys.ROW_COUNT,
      order: hideCheckboxColumn ? 4 : 5,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
  );

  if (showDownloadColumn) {
    headers.push({
      label: "Download",
      key: PushToSftpModalTableColumnKeys.DOWNLOAD,
      order: 6,
      width: 8,
      type: TableCellType.DOWNLOAD_ICON,
      sortable: false,
    });
  }

  return headers;
};
